<nav class="navbar navbar-expand-lg bg-light shadow" id="page-topbar">
    <div class="container-fluid navbar-top">
        <div class="d-flex gap-2">
            <a class="navbar-brand xs-hidden sm-hidden" style="padding: 0" href="#">
                <img src="assets/images/logo-kanaka.png" class="p-2" alt="" height="22" />
            </a>

            <div class="d-flex" style="font-weight: 600;">
                <div class="mx-2 d-flex align-items-center">
                    <a style="color: #585858;" [routerLink]="['/panel']" href="javascript: void(0);">
                        Pengajuan
                    </a>
                </div>
                <div class="mx-2 d-flex align-items-center">
                    <a style="color: #585858;" [routerLink]="['/panel/history-pengajuan']" href="javascript: void(0);">
                        History Pengajuan
                    </a>
                </div>
                <div class="mx-2 d-flex align-items-center">
                    <a style="color: #585858;" [routerLink]="['/panel/data-diri']" href="javascript: void(0);">
                        Profil
                    </a>
                </div>
            </div>
        </div>


        <div class="d-flex adivgn-items-center">
            <div class="d-flex mobile-profile align-items-center br-1">
                <div class="dropdown d-inline-block dropdown-notifikasi" #dropdown="ngbDropdown" ngbDropdown>
                    <button type="button" class="btn text-dark" id="page-header-user-dropdown" ngbDropdownToggle>
                        <div class="btn-notif">
                            <div style="-webkit-mask: url(assets/icons/icon_Bell.png) center/contain;
                        mask: url(assets/icons/icon_Bell.png) center/contain;" class="iconTopbar">
                            </div>
                            <div class="icon-badge" *ngIf="unmarked_notifications > 0">
                                {{unmarked_notifications}}
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu-right listNotifikasi-menu p-0 conDropdownProfil" ngbDropdownMenu
                        style="border-radius: 5px;">
                        <div class="d-flex justify-content-between px-3 py-3">
                            <div class=" fs-16 text-bold m-0">
                                Notifikasi
                            </div>
                            <a class="align-middle my-auto text-primary" *ngIf="unmarked_notifications > 0"
                                (click)="readAllNotif();" role="button">
                                Baca Semua
                            </a>

                        </div>
                        <hr class="mx-2 my-0">

                        <div class="notifikasi-body mt-1 bt-1 pb-3">
                            <div class="pl-3 pt-3 pb-2 mt-1 d-flex" role="button" (click)="setExpandMessage(val);"
                                (mouseover)='showActionNotif(val.id)' (mouseout)='hideActionNotif(val.id)'
                                [id]="'card-notif-' + val.id" *ngFor="let val of listNotifikasi"
                                [ngClass]="{'bg-soft-gray': val.marked == false}">
                                <div class="icon-notifikasi">
                                    <div class="btn btn-soft-warning height-fit-content"
                                        *ngIf="val.reff_type == 'reminder'">
                                        <i class="fas fa-calendar-alt icon-warning"></i>
                                    </div>
                                    <div class="btn btn-soft-danger height-fit-content"
                                        *ngIf="val.reff_type == 'expired'">
                                        <i class="fas fa-calendar-alt icon-danger"></i>
                                    </div>
                                    <div class="btn btn-soft-blue height-fit-content"
                                        *ngIf="val.reff_type == 'comment'">
                                        <i class="fas fa-comment icon-blue"></i>
                                    </div>

                                </div>
                                <div class="main-notifikasi">
                                    <div class="text-bold font-size-14">{{val.title}}</div>
                                    <p class="font-size-12"
                                        [innerHTML]="val.is_full || val.message.length < max_length_message ? val.message : (val.message | slice:0:max_length_message) + '...'">
                                    </p>
                                    <div class="pt-1">
                                        <div class="text-semi-bold font-size-12" *ngIf="val.date_diff >= 1">
                                            {{val.date_diff}} hari yang lalu</div>
                                        <div class="text-semi-bold font-size-12" *ngIf="val.date_diff == 0">Hari
                                            ini</div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="listNotifikasi.length < 1">
                                <div class="p-4 mb-2 text-center">
                                    <i>Data Kosong</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mobile-profile">
                <!-- <div class="dropdown d-none d-lg-inline-block ml-1">
                    <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
                        <em class="bx bx-fullscreen text-dark"></em>
                    </button>
                </div> -->
                <div class="dropdown d-inline-block" ngbDropdown>
                    <button type="button" class="btn header-item text-dark" id="page-header-user-dropdown"
                        ngbDropdownToggle>
                        <!-- <img class="rounded-circle header-profile-user" *ngIf="userLogin.photo_url"
                            src="{{userLogin.photo_url}}" alt="User Avatar" />
                        <em *ngIf="!userLogin.photo_url" class="fa fa-user"></em> -->
                        <span class="d-none d-xl-inline-block ml-1">{{userLogin.name}}</span>
                        <em class="mdi mdi-chevron-down d-none d-xl-inline-block"></em>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                        <a class="dropdown-item " href="javascript: void(0);" [routerLink]="['/user']"
                            *ngIf="authService.checkAccess('user.view')">
                            <em class="bx bx-user font-size-16 align-middle mr-1"></em>
                            User
                        </a>
                        <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
                            <em class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></em>
                            Logout
                        </a>
                    </div>
                </div>
            </div>


        </div>
    </div>
</nav>